import React from "react";
import { ModalHeader } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalHeader";
import { ModalBody } from "nvs-design-system/dist/Modals/RoundedModal/components/ModalBody";
import TokenTransferStep, {
  TokenTransferStepProps,
} from "../TokenTransferStep";
import TokenTransferStepButton from "../TokenTransferStepButton";
import FAQsLink from "../FAQsLink";
import { Body5 } from "@/src/components/typography/components/Body";

export default function WhatToExpect({
  isShowing = false,
  onContinue,
}: TokenTransferStepProps) {
  return (
    <TokenTransferStep isShowing={isShowing}>
      <ModalHeader>What to expect</ModalHeader>

      <ModalBody className="flex flex-col gap-6">
        <BodyCopy />
        <FAQsLink />
      </ModalBody>

      <TokenTransferStepButton onClick={onContinue} className="!leading-5">
        Begin Transfer
      </TokenTransferStepButton>
    </TokenTransferStep>
  );
}

function BodyCopy() {
  return (
    <>
      <Body5>
        To begin the process of transferring your Nike Virtual Creation, you
        will need a few pieces of information.
      </Body5>

      <ul className="list-disc list-outside pl-4">
        <li>
          A two-step verification code we will send to your phone number during
          the process
        </li>
        <li>
          The address of the wallet you’d like to send your Nike Virtual
          Creation to
        </li>
      </ul>
    </>
  );
}
